export enum TipoPagamentoID {
  cartao = '4EF3D0AD-ABAF-4F2F-BCA3-C8402EFA72F7',
  pix = 'ED12FF2F-FA0D-4F32-A361-01FD460D7D7D',
}
